import React, { Component } from 'react';
import block from 'bem-cn-lite';
import Column from './Column';
import { getBoards, getTasks } from './services';
import { issues } from './data';
import DragDropContext from '../utils/dndcontext';
import CustomDragLayer from './Task/dragLayer';
import { TransitionGroup } from 'react-transition-group';
import InfoTooltip from '../Components/InfoTooltip'
import createCustomEvent from '../createCustomEvent'
import TopMenu from '../Components/TopMenu'
import { I18n } from 'react-i18next'

block.setup({
    mod: '--'
});
const b = block('Boards');
const tooltip = block('Tooltip');

const columns = getBoards();

class Boards extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: getBoards(),
            tasks: getTasks() || [],
            animate: false,
            currentDrag: { id: 0, assignees: [1, 2, 3] },
            issues: ['intro']
        };
        this.moveTask = this.moveTask.bind(this);
        this.dragHappening = this.dragHappening.bind(this);
        this.dropHappening = this.dropHappening.bind(this);
        this.moveTaskBefore = this.moveTaskBefore.bind(this);
        this.addIssue = this.addIssue.bind(this);
    }
    getIssueById(id) {
        const issue = issues.find(issue => issue.id === id);
        return issue ? issue.text : false;
    }
    removeIssue(id) {
        const index = this.state.issues.indexOf(id);
        if (index > -1) {
            this.setState({
                issues: this.state.issues.splice()
            });
        }
    }
    addIssue(id) {
        if (this.state.issues.indexOf(id) === -1) {
            this.setState({
                issues: [id, ...this.state.issues]
            });
        }
    }
    moveTask(taskId, boardId) {
        let newTasksArray = this.state.tasks;
        let tasks = this.getTasksByColumn(boardId);
        let order = 0;
        this.setState({animate: true})
        
        if (tasks.length > 0) {
            order = tasks.reduce(
                (maxValue, task) =>
                    task.order > maxValue ? task.order : maxValue,
                0
            );
        }
        newTasksArray[this.getTaskIndexById(taskId)] = {
            ...newTasksArray[this.getTaskIndexById(taskId)],
            column: boardId,
            order: order + 1
        };
        this.setState({
            tasks: newTasksArray
        });
    }
    updateTasks(tasks) {
        const currentTasks = this.state.tasks;
        currentTasks.map(task => {
            const foundTask = tasks.find(t => t.id === task.id);
            if (foundTask) {
                return foundTask;
            } else {
                return task;
            }
        });
        return currentTasks;
    }
    moveTaskBefore(taskId, targetTaskId, before = false) {
        let newTasksArray = this.state.tasks;
        
        const targetColumn = this.getTaskById(targetTaskId).column;
        const targetTask = this.getTaskById(targetTaskId);
        //
        newTasksArray = this.increaseOrderStartingFrom(
            targetColumn,
            before ? targetTask.order : targetTask.order + 1
        );

        newTasksArray[this.getTaskIndexById(taskId)] = {
            ...newTasksArray[this.getTaskIndexById(taskId)],
            column: targetColumn,
            order: targetTask.order + (before ? -1 : 1)
        };
        this.setState({
            tasks: newTasksArray
        });
    }
    dropHappening(taskId, boardId) {
        let task = this.getTaskById(taskId)
        let board = this.getBoardById(boardId)
        let newState = {
            currentDrag: { id: 0, assignees: [1, 2, 3] }
        }

        if(task.marked && board.marked) {
            let newTasksArray = [].concat(this.state.tasks);
            let newBoarbsArray = [].concat(this.state.columns);

            let taskIndex = this.getTaskIndexById(taskId)
            let boardIndex = this.getBoardIndexById(boardId)

            newTasksArray[taskIndex] = {
                ...task,
                marked: false
            }
            
            newBoarbsArray[boardIndex] = {
                ...board,
                marked: false
            }

            newState = {
                ...newState,
                tasks: newTasksArray,
                columns: newBoarbsArray
            }
        }
        this.setState(newState);
        window.dispatchEvent(createCustomEvent('IS_BOARDS__TASK_MOVED', { detail: { task: task.name, board: board.name } }))
    }
    dragHappening(taskId) {
        this.removeIssue('trial');
        this.removeIssue('intro');
        this.setState({
            currentDrag: this.getTaskById(taskId)
        });
    }
    increaseOrderStartingFrom(column, order) {
        const tasks = this.getTasksByColumn(column);
        const tasksToUpdate = tasks.filter(task => task.order >= order);
        return this.updateTasks(
            tasksToUpdate.map(task =>
                Object.assign(task, { order: task.order + 1 })
            )
        );
    }
    getTaskIndexById(id) {
        return this.state.tasks.findIndex(task => task.id === id);
    }
    getTaskById(id) {
        return this.state.tasks.find(task => task.id === id);
    }
    getTasksByColumn(id) {
        return this.state.tasks
            .filter(task => task.column === id)
            .sort((task, next) => task.order - next.order);
    }
    getBoardById(id) {
        return this.state.columns.find(column => column.id === id)
    }
    getBoardIndexById(id) {
        return this.state.columns.findIndex(column => column.id === id)
    }
    componentWillUpdate() {
        if (this.state.tasks.length === this.getTasksByColumn(1).length) {
            this.addIssue('allnew');
        } else {
            this.removeIssue('allnew');
        }
        if (this.state.tasks.length === this.getTasksByColumn(2).length) {
            this.addIssue('allprogress');
        } else {
            this.removeIssue('allprogress');
        }
        if (this.state.tasks.length === this.getTasksByColumn(3).length) {
            this.addIssue('alldone');
        } else {
            this.removeIssue('alldone');
        }
    }
    render() {
        return (
            <I18n>
            {
                (t) => (
                    <div className={b()}>
                        <div
                            className={b('header')}
                            onClick={e => {
                                this.addIssue('trial');
                            }}
                        >
                            <div className={b('title')}>{t('boards:title')}</div>

                            <div className={b('menu')}>
                                <TopMenu items={ [t('global:board'), t('global:stream'), t('global:more')] } current={0} />
                            </div>
                        </div>
                        <div className={tooltip('wrapper')}>
                            <InfoTooltip text={this.getIssueById(this.state.issues[0])}/>
                        </div>
                        <TransitionGroup>
                            <CustomDragLayer {...this.state.currentDrag} dragging={true} />
                        </TransitionGroup>
                        {columns.map(column =>
                            <Column
                                onTaskChange={this.moveTaskBefore}
                                onChange={this.moveTask}
                                onDrop={this.dropHappening}
                                onDrag={this.dragHappening}
                                currentDrag={this.state.currentDrag}
                                insertBefore={this.moveTaskBefore}
                                key={column.id}
                                animate={this.state.animate}
                                tasks={this.getTasksByColumn(column.id)}
                                {...column}
                            />
                        )}
                    </div>
                )
            }
            </I18n>
        );
    }
}

export default DragDropContext(Boards);
